import { create } from "zustand";
import { persist } from 'zustand/middleware';

const useItemStore = create(
  persist((set, get) => ({
    items: [],
    setItems: (value) => set({ items: value }),
    updateItem: (updatedItem) => set((state) => ({
      items: state.items.map((item) => item.id === updatedItem.id ? { ...item, ...updatedItem } : item)
    })),
    addItem: (item) => set((state) => ({
      items: [...state.items, item]
    })),
    removeItem: (removedItem) => set((state) => ({
      items: state.items.filter((item) => removedItem.id !== item.id)
    })),
    itemById: (id) => get().items.find((o) => o.id == id),
    itemsByCategoryId: (id) => get().items.filter((o) => o.item_category_id == id),

    itemCategories: [],
    setItemCategories: (value) => set({ itemCategories: value }),
    updateItemCategory: (updatedItemCategory) => set((state) => ({
      itemCategories: state.itemCategories.map((itemCategory) => itemCategory.id === updatedItemCategory.id ? { ...itemCategory, ...updatedItemCategory } : itemCategory)
    })),
    addItemCategory: (itemCategory) => set((state) => ({
      itemCategories: [...state.itemCategories, itemCategory]
    })),
    removeItemCategory: (itemCategory) => set((state) => ({
      itemCategories: state.itemCategories.filter((category) => category.id !== itemCategory.id)
    })),
  }), {
    name: 'item-storage', // unique name
  })
);

export default useItemStore;